<div class="usan-form-item statement-of-adoption-container">
    <div class="usan-checklist-item">
        <div class="usan-checklist-icon-column">
            <mat-icon>{{ hasStatementOfAdoptionFile ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
        </div>
        <div class="usan-checklist-content-column flex-wrap">
            <span class="usan-form-item statement-of-adoption-item statement-of-adoption-text">Adoption Statement</span>
            <div class="break"></div>
            <span class="usan-form-item statement-of-adoption-item statement-of-adoption-text">
                <ng-container *ngIf="!isFormDType">A copy of the adoption statement for the substance that has received a USAN or include the USAN file number if adoption has not yet taken place</ng-container>
                <ng-container *ngIf="isFormDType">A copy of the statement of adoption published for this substance</ng-container>
            </span>
        </div>
    </div>
    <div class="usan-form-item button-layout layout-centered">
        <button type="button" class="upload-statement-of-adoption form-btn form-btn-style form-btn-text"
            (click)="openDialog()">
            <mat-icon class="form-btn-icon">upload</mat-icon>
            Upload Statement of Adoption
        </button>
    </div>
    <ng-container *ngIf="hasStatementOfAdoptionFile">
    <div class="full-width" *ngFor="let file of attachments">
      <app-uploaded-file [requiresAdmin]="false" [attachment]="file"></app-uploaded-file>
    </div>
  </ng-container>
</div>